export function debounce(func: any, time: number = 200) {
  let timer: any
  return function (event?: any) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, time, event)
  }
}
